function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { MedicalRecordContext } from 'context';
import * as selectors from 'modules/PatientResults/selectors';
import messages from 'modules/PatientResults/messages';
import { CGM_GOALS } from '../../../constants';
import styles from '../GlucoseConcentrationLevels.pcss';
import LinkEndLine from './LinkEndLine';
const Goal = ({ aGCL })=>{
    const medicalRecord = useContext(MedicalRecordContext);
    const showGoals = useSelector(selectors.showCGMGoals);
    const { dataType } = medicalRecord;
    if (dataType === 'BGM' || !showGoals || !CGM_GOALS[aGCL.name]) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.aggregate, styles.goal),
        children: [
            /*#__PURE__*/ _jsx(LinkEndLine, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.aggregate__value, 'd-flex align-items-center'),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text--small mr-2",
                        children: [
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseConcentrationLevels.goal)),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: CGM_GOALS[aGCL.name]
                    })
                ]
            })
        ]
    });
};
export default /*#__PURE__*/ memo(Goal);
